export const PARENT_ALLOWED_ORIGINS: string[] = ["*"];
